import { render } from "./AlbaranPtlComponent.vue?vue&type=template&id=8584cb9e&scoped=true"
import script from "./AlbaranPtlComponent.vue?vue&type=script&lang=js"
export * from "./AlbaranPtlComponent.vue?vue&type=script&lang=js"

import "./AlbaranPtlComponent.vue?vue&type=style&index=0&id=8584cb9e&scoped=true&lang=scss"

import exportComponent from "C:\\GIT CLONADO\\ubiku.2023\\com.ubiku.ges.ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8584cb9e"]])

export default __exports__